{
  "appName": "سحاب ERP",
  "loading": "جارٍ التحميل…",
  "notifications": "الإشعارات",
  "newTab": "(تُفتح في علامة تبويب جديدة)",
  "currency": {
    "omr": "ريال عماني"
  },
  "filters": {
    "button": "التصفية",
    "title": "التصفية",
    "clear": "مسح التصفية",
    "done": "عرض النتائج"
  },
  "quickCreate": {
    "typed": "{{label}} «{{typed}}»"
  },
  "actions": {
    "cancel": "إلغاء",
    "close": "إغلاق",
    "retry": "إعادة المحاولة",
    "edit": "تعديل",
    "more": "إجراءات أخرى",
    "print": "طباعة",
    "save": "حفظ",
    "scrollBack": "تمرير للخلف",
    "scrollForward": "تمرير للأمام"
  },
  "errors": {
    "title": "حدث خطأ",
    "notFoundTitle": "غير موجود",
    "forbiddenTitle": "لا توجد صلاحية",
    "moduleDisabledTitle": "غير مفعّل",
    "unexpected": "حدث خطأ غير متوقع. أعد تحميل الصفحة وحاول مرة أخرى.",
    "network": "تعذّر الوصول إلى الخادم. تحقق من الاتصال وحاول مرة أخرى.",
    "unavailable": "الخادم لا يستجيب. حاول مرة أخرى بعد قليل.",
    "unauthenticated": "انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة.",
    "forbidden": "ليست لديك صلاحية لهذا الإجراء. اطلب الصلاحية من مسؤول النظام.",
    "moduleDisabled": "هذه الميزة غير مفعّلة لشركتك. اطلب من مسؤول النظام تفعيلها.",
    "notFound": "هذا السجل غير موجود أو تمت إزالته.",
    "conflict": "يتعارض هذا مع سجل موجود. راجع الحقول المحددة.",
    "versionConflict": "عدّل شخص آخر هذا السجل. أعد التحميل للحصول على أحدث نسخة.",
    "rateLimited": "طلبات كثيرة جدًا. انتظر قليلًا وحاول مرة أخرى.",
    "passwordChangeRequired": "غيّر كلمة المرور للمتابعة.",
    "periodLocked": "الدفاتر مقفلة حتى {{date}}: لا يمكن ترحيل أي شيء مؤرخ في ذلك اليوم أو قبله ولا إلغاؤه ولا عكسه. استخدم تاريخًا لاحقًا، أو اطلب ممن يدير السنوات المالية نقل تاريخ الإقفال من الإعدادات.",
    "periodLockedNoDate": "الدفاتر مقفلة لهذا التاريخ: لا يمكن ترحيل أي شيء مؤرخ في تاريخ الإقفال أو قبله ولا إلغاؤه ولا عكسه. استخدم تاريخًا لاحقًا، أو اطلب ممن يدير السنوات المالية نقل تاريخ الإقفال من الإعدادات.",
    "periodLockedOff": "الدفاتر مقفلة حتى {{date}}: لا يمكن ترحيل أي شيء مؤرخ في ذلك اليوم أو قبله ولا إلغاؤه ولا عكسه. استخدم تاريخًا لاحقًا. المحاسبة غير مفعّلة لشركتك، فلا يستطيع أحد هنا نقل تاريخ الإقفال: اطلب ذلك من مزوّد الخدمة.",
    "periodLockedNoDateOff": "الدفاتر مقفلة لهذا التاريخ: لا يمكن ترحيل أي شيء مؤرخ في تاريخ الإقفال أو قبله ولا إلغاؤه ولا عكسه. استخدم تاريخًا لاحقًا. المحاسبة غير مفعّلة لشركتك، فلا يستطيع أحد هنا نقل تاريخ الإقفال: اطلب ذلك من مزوّد الخدمة.",
    "periodClosed": "السنة المالية لهذا التاريخ مقفلة: لا يمكن ترحيل أي شيء مؤرخ فيها ولا إلغاؤه ولا عكسه. استخدم تاريخًا في سنة مفتوحة.",
    "periodClosedOff": "السنة المالية لهذا التاريخ مقفلة: لا يمكن ترحيل أي شيء مؤرخ فيها ولا إلغاؤه ولا عكسه. استخدم تاريخًا في سنة مفتوحة. المحاسبة غير مفعّلة لشركتك، فلا يستطيع أحد هنا إعادة فتحها: اطلب ذلك من مزوّد الخدمة.",
    "noFiscalYear": "لا توجد سنة مالية تغطي هذا التاريخ. استخدم تاريخًا آخر، أو اطلب ممن يدير السنوات المالية إضافتها.",
    "noFiscalYearOff": "لا توجد سنة مالية تغطي هذا التاريخ. استخدم تاريخًا آخر. المحاسبة غير مفعّلة لشركتك، فلا يستطيع أحد هنا إضافة سنة مالية: اطلب ذلك من مزوّد الخدمة.",
    "bankLineMatched": "سطره المصرفي مطابَق في كشف الحساب المصرفي {{number}}. ألغِ المطابقة في ذلك الكشف أولًا، ثم أعد المحاولة.",
    "bankLineMatchedCompleted": "سطره المصرفي مطابَق في كشف الحساب المصرفي {{number}}، وهو كشف مكتمل. أعد فتح ذلك الكشف وألغِ مطابقة السطر أولًا، ثم أعد المحاولة.",
    "validation": "بعض الحقول تحتاج إلى تصحيح. صححها وحاول مرة أخرى.",
    "internal": "واجه الخادم مشكلة. حاول مرة أخرى، وإذا تكررت فتواصل مع الدعم مع ذكر المرجع أدناه.",
    "rejected": "تعذّر إكمال الطلب.",
    "reference": "المرجع:",
    "notFoundPage": "الصفحة غير موجودة",
    "notFoundPageBody": "ربما كُتب العنوان بشكل خاطئ، أو نُقلت الصفحة.",
    "goHome": "الذهاب إلى الرئيسية",
    "codes": {
      "MESSAGE_NOT_RETRYABLE": "لا يمكن إعادة الإرسال إلا لرسالة فشل إرسالها.",
      "TEMPLATE_UNKNOWN_VARIABLE": "يستخدم النص متغيرًا غير موجود في هذا القالب. احذفه أو اختر متغيرًا من القائمة.",
      "INVOICE_NOT_SENDABLE": "لا يمكن إرسال الفاتورة بالبريد الإلكتروني إلا بعد ترحيلها.",
      "ADAPTER_NOT_ALLOWED_IN_ZONE": "خدمة البريد هذه غير مسموح بها في موقع حفظ بيانات شركتك. استخدم خدمة أخرى، أو أكّد أن خادمك معتمد لهذا الموقع.",
      "DOCUMENT_RENDERING": "ما زال ملف PDF قيد الإعداد. حاول مرة أخرى بعد قليل.",
      "DOCUMENT_FAILED": "تعذّر إنشاء ملف PDF. حاول إصداره مرة أخرى.",
      "DOCUMENT_NOT_ISSUABLE": "لا يمكن إصدار ملف PDF لمستند مسودة أو ملغى.",
      "CUSTOMER_ANONYMISED": "حُذفت البيانات الشخصية لهذا العميل، لذا لم يعد بالإمكان تعديل السجل أو استعادته.",
      "RETENTION_BELOW_FLOOR": "المدة أقصر مما يسمح به القانون لهذه البيانات. استخدم مدة أطول.",
      "LEGAL_HOLD": "هذا السجل خاضع لحجز قانوني. ارفع الحجز أولًا.",
      "DSR_ILLEGAL_TRANSITION": "لا يمكن نقل الطلب إلى هذه الخطوة من حالته الحالية. أعد التحميل لمعرفة حالته.",
      "DSR_SUBJECT_REFERENCED": "يجب الاحتفاظ بهذه البيانات للسجلات القانونية والضريبية: تشير إليها مستندات صادرة.",
      "UPLOADS_PAUSED": "رفع الملفات متوقف مؤقتًا أثناء نقل ملفات شركتك إلى موقع آخر. حاول لاحقًا.",
      "RESIDENCY_MOVE_ACTIVE": "هناك عملية نقل لبيانات هذه الشركة قيد التنفيذ بالفعل.",
      "ZONE_NOT_CONFIGURED": "موقع البيانات هذا غير متاح في هذه الخدمة بعد.",
      "INVITATION_INVALID": "رابط الدعوة هذا لم يعد صالحًا. اطلب من المسؤول إرسال دعوة جديدة.",
      "SMTP_INCOMPLETE": "للإرسال عبر خادم البريد الخاص بك، أدخل عنوان الخادم واسم المستخدم وعنوان المرسل.",
      "SMTP_HOST_NOT_ALLOWED": "عنوان خادم البريد هذا على شبكة خاصة. أدخل الاسم العام لخادم بريدك.",
      "BOOKS_READ_TIMEOUT": "استغرقت قراءة الدفاتر وقتًا طويلًا. جرّب فترة أقصر.",
      "BOOKS_HEALTH_UNAVAILABLE": "تعذّرت قراءة سلامة الدفاتر الآن. حاول مرة أخرى بعد دقائق.",
      "SALESPERSON_INVALID": "اختر مستخدمًا نشطًا مندوبًا للمبيعات.",
      "HEALTH_PERIOD": "تغطي سلامة الدفاتر فترة محدودة في كل مرة. اختر فترة أقصر.",
      "DISMISSAL_CONFLICT": "أشّر مستخدم آخر على هذه النتيجة في الوقت نفسه. أعد التحميل وحاول مرة أخرى.",
      "YEAR_CLOSED": "هذه السنة المالية مغلقة بالفعل. أعد التحميل لترى حالتها.",
      "YEAR_NOT_ENDED": "لا يمكن إغلاق السنة المالية إلا بعد آخر يوم فيها.",
      "PREVIOUS_YEAR_OPEN": "ما زالت سنة مالية سابقة مفتوحة. أغلق السنوات السابقة أولًا.",
      "YEAR_OPEN": "هذه السنة المالية غير مغلقة، فلا شيء لإعادة فتحه. أعد التحميل لترى حالتها.",
      "LATER_YEAR_CLOSED": "توجد سنة مالية لاحقة مغلقة. أعد فتح السنوات اللاحقة أولًا.",
      "DOCUMENT_ENTRY": "رُحّل هذا القيد من مستند. ألغِ ذلك المستند لعكس القيد.",
      "CLOSING_ENTRY": "هذا قيد إقفال سنة مالية. أعد فتح السنة المالية لعكسه.",
      "PRODUCT_NOT_STOCKED": "الخدمة لا تُحفظ في المخزون، لذا ليس لها حد إعادة طلب.",
      "VARIANT_ARCHIVED": "حُذف هذا المتغير من منتجه. أعد تحميل الصفحة.",
      "NO_WALK_IN_CUSTOMER": "تعذّر إعداد العميل النقدي: عميل آخر يستخدم الرمز WALK-IN. غيّر رمز ذلك العميل ثم حاول مرة أخرى."
    }
  },
  "validation": {
    "required": "مطلوب",
    "minLength": "أدخل {{min}} أحرف على الأقل",
    "maxLength": "استخدم {{max}} حرفًا أو أقل",
    "tooMany": "اختر {{max}} أو أقل",
    "email": "أدخل بريدًا إلكترونيًا صحيحًا، مثل name@company.om",
    "phone": "أدخل رقم هاتف صحيحًا (أرقام ومسافات و + و - فقط)",
    "format": "تحقق من صيغة هذه القيمة",
    "invalid": "هذه القيمة غير صالحة",
    "passwordLength": "استخدم 10 أحرف على الأقل",
    "passwordSpaces": "لا يمكن أن تبدأ كلمة المرور أو تنتهي بمسافة",
    "passwordSame": "اختر كلمة مرور مختلفة عن الحالية",
    "journalLine": "أدخل مبلغًا مدينًا أو دائنًا في هذا السطر",
    "journalTwoLines": "يحتاج القيد إلى سطرين على الأقل",
    "describe": "أضف وصفًا",
    "positiveAmount": "أدخل مبلغًا أكبر من صفر",
    "chequeNumber": "أدخل رقم الشيك",
    "endBeforeStart": "لا يمكن أن يسبق تاريخ الانتهاء تاريخ البدء",
    "endOneWay": "اختر تاريخ انتهاء أو عدد مرات، لا كليهما",
    "noDateBeforeEnd": "لا يقع أي موعد قبل تاريخ الانتهاء",
    "startOnExpense": "يجب أن يبدأ الجدول في تاريخ المصروف",
    "reason": "اذكر السبب",
    "accountCode": "استخدم الحروف أو الأرقام أو النقاط أو الشرطات",
    "sameAccount": "اختر حسابًا مختلفًا للتحويل إليه",
    "percentage": "أدخل نسبة مئوية بمنزلتين عشريتين كحد أقصى",
    "percentageMax": "لا يمكن أن تزيد النسبة على 100%",
    "taxCategory": "النسبة الأساسية أكبر من 0٪؛ ونسب الصفر والمعفاة وخارج النطاق 0٪",
    "describeLine": "اكتب وصف البند أو اختر منتجًا",
    "positiveQuantity": "أدخل كمية أكبر من صفر",
    "negativePrice": "لا يمكن أن يكون السعر سالبًا",
    "atLeastOneLine": "أضف بندًا واحدًا على الأقل",
    "dueBeforeInvoice": "لا يمكن أن يسبق تاريخ الاستحقاق تاريخ الفاتورة",
    "validUntilBefore": "لا يمكن أن يسبق تاريخ الصلاحية تاريخ عرض السعر",
    "activeCustomer": "اختر عميلًا نشطًا",
    "activeProduct": "اختر منتجًا نشطًا",
    "activeTaxRate": "اختر نسبة ضريبة نشطة",
    "activeWarehouse": "اختر مستودعًا نشطًا",
    "wholeUnits": "هذا المنتج يُعدّ بوحدات كاملة",
    "creditBeforeInvoice": "لا يمكن أن يسبق تاريخ الإشعار الدائن تاريخ فاتورته",
    "inactiveCustomer": "هذا العميل غير نشط. أعد تنشيطه أو اختر عميلًا آخر",
    "otherCustomerInvoice": "هذه الفاتورة تخص عميلًا آخر",
    "invoiceNotCreditable": "لا يمكن إصدار إشعار دائن إلا على فاتورة مرحّلة",
    "returnShareTooSmall": "أرجع هذا البند بكميات أكبر: مبالغ الوحدة الواحدة أقل من بيسة واحدة",
    "invoiceTaxRate": "اختر نسبة ضريبة فُرضت في الفاتورة",
    "invoiceTaxRateAmbiguous": "فُرضت هذه الضريبة في الفاتورة بأكثر من نسبة واحدة",
    "restoreProductToReturn": "هذا المنتج مؤرشف: استعِده قبل استرجاع البضاعة",
    "debitNoteGoods": "الإشعار المدين يحمّل خدمات أو مبالغ؛ أما البضائع فتُفوتر",
    "addValue": "أضف قيمة واحدة على الأقل",
    "oneVariant": "يحتاج المنتج إلى متغير واحد على الأقل",
    "cost": "أدخل تكلفة تساوي 0 أو أكثر، بست منازل عشرية كحد أقصى",
    "warehouseCode": "استخدم الحروف أو الأرقام أو الشرطات أو الشرطات السفلية",
    "dueBeforePurchase": "لا يمكن أن يسبق تاريخ الاستحقاق تاريخ الشراء",
    "activeSupplier": "اختر موردًا نشطًا",
    "goodsNoAccount": "البضائع تُحمَّل على المخزون؛ اترك الحساب فارغًا",
    "expenseAccount": "اختر حساب مصروف أو أصل نشطًا (ليس حساب نقدية أو بنك أو مخزون أو ذمم مدينة)",
    "chargeableAccount": "اختر حساب مصروف أو أصل نشطًا (ليس حساب نقدية أو بنك، ولا حسابًا تحدد المستندات رصيده: المخزون أو الذمم المدينة أو الدائنة أو الشيكات برسم التحصيل أو الصادرة أو الدفعات المقدمة من العملاء أو المحتجزات أو ضريبة القيمة المضافة)",
    "activeTreasury": "اختر حساب نقدية أو بنك نشطًا",
    "methodAccount": "اختر حسابًا نشطًا يناسب طريقة الدفع هذه",
    "tillDrawer": "هذا درج صندوق: اختر حسابًا آخر",
    "cashAccountMethods": "يقبل حساب النقدية النقد أو الشيكات فقط",
    "cashAccountOnly": "يُسجَّل النقد في حساب نقدية فقط",
    "otherSupplierPurchase": "فاتورة الشراء هذه تخص موردًا آخر",
    "purchaseNotPosted": "لا يمكن تسوية إلا فواتير الشراء المرحّلة",
    "purchaseNotReturnable": "لا يمكن إرجاع أو تخفيض إلا فواتير الشراء المرحّلة",
    "returnBeforePurchase": "لا يمكن أن يسبق تاريخ مرتجع المورد تاريخ فاتورة الشراء",
    "returnLineOnce": "أرجع كل بند من فاتورة الشراء مرة واحدة",
    "lineNotOnPurchase": "هذا البند ليس في فاتورة الشراء",
    "refundCredit": "اختر الرصيد المراد استرداده",
    "refundBeforeCredit": "لا يمكن أن يسبق تاريخ الاسترداد تاريخ الرصيد الذي يُسترد",
    "otherCustomerCredit": "هذا الرصيد يخص عميلًا آخر",
    "creditNotFound": "لم يُعثر على هذا الرصيد",
    "tillCode": "استخدم 32 حرفًا أو رقمًا أو شرطة أو شرطة سفلية كحد أقصى",
    "notNegative": "لا يمكن أن تكون القيمة سالبة",
    "denomination": "ليست ورقة نقدية أو عملة معدنية مقبولة",
    "wholeCount": "عُدّ الأوراق والعملات المعدنية بأعداد صحيحة",
    "countDrawer": "عُدّ الدرج قبل الإغلاق",
    "denominationOnce": "أدخل كل ورقة أو عملة مرة واحدة",
    "positiveDiscount": "أدخل خصمًا أكبر من صفر",
    "percentOver100": "لا يمكن أن تزيد النسبة على 100",
    "atLeastOneItem": "أضف صنفًا واحدًا على الأقل",
    "cashOnce": "أدخل النقد مرة واحدة",
    "noCashTender": "لا يوجد دفع نقدي",
    "cashTenderedShort": "النقد المسلَّم أقل من المبلغ النقدي المدفوع",
    "negativeDiscount": "لا يمكن أن يكون الخصم سالبًا",
    "notDrawer": "اختر الخزنة أو البنك، لا درج الصندوق",
    "tillNotFound": "لم يُعثر على هذا الصندوق",
    "discountOverSale": "الخصم أكبر من قيمة البيع",
    "nonZeroAmount": "لا يمكن أن يكون مبلغ الحركة صفرًا",
    "periodEnd": "لا يمكن أن تنتهي الفترة قبل بدايتها",
    "outsidePeriod": "التاريخ خارج فترة الكشف",
    "chooseStatementLine": "اختر سطرًا واحدًا على الأقل من الكشف",
    "listedTwice": "ورد سطر مرتين",
    "bankAccount": "اختر حسابًا بنكيًا",
    "notCashAccount": "حسابات النقدية تُجرد ولا تُسوّى: اختر حسابًا بنكيًا أو جهاز بطاقات أو محفظة",
    "lineNotOnStatement": "أحد الأسطر ليس في هذا الكشف",
    "postableAccount": "اختر حسابًا نشطًا يقبل الترحيل",
    "adjustmentAccount": "اختر حساب إيرادات أو مصروفات (لا حساب نقدية أو بنك أو ذمم مدينة أو دائنة أو مخزون أو ضريبة أو أرصدة عملاء)",
    "cashAtTill": "النقد في نقطة البيع يذهب إلى الدرج",
    "paymentMethodTaken": "توجد طريقة دفع بهذا الاسم",
    "paymentMethodTypeUsed": "سُجلت مستندات بهذه الطريقة: لا يمكن تغيير نوعها",
    "accountTakesType": "هذا الحساب لا يقبل هذا النوع",
    "activePaymentMethod": "اختر طريقة دفع نشطة",
    "notAtTill": "هذه الطريقة غير متاحة في نقطة البيع"
  },
  "pagination": {
    "label": "الصفحات",
    "range": "{{from}}–{{to}} من {{total}}",
    "pageSize": "عدد الصفوف في الصفحة",
    "perPage": "{{n}} في الصفحة",
    "previous": "الصفحة السابقة",
    "next": "الصفحة التالية",
    "page": "الصفحة {{page}}",
    "pageOf": "الصفحة {{page}} من {{pages}}"
  },
  "table": {
    "view": "العرض",
    "density": "كثافة الصفوف",
    "compact": "مضغوط",
    "comfortable": "مريح",
    "columns": "الأعمدة",
    "empty": "لا يوجد ما يُعرض.",
    "actions": "الإجراءات",
    "rowActions": "إجراءات الصف",
    "export": "تصدير",
    "selectAll": "تحديد الكل في هذه الصفحة",
    "selectRow": "تحديد الصف",
    "selected_zero": "لم يُحدَّد شيء",
    "selected_one": "صف واحد محدد",
    "selected_two": "صفّان محددان",
    "selected_few": "{{n}} صفوف محددة",
    "selected_many": "{{n}} صفًا محددًا",
    "selected_other": "{{n}} صف محدد",
    "clearSelection": "إلغاء التحديد",
    "selection": "الصفوف المحددة",
    "cannotSelect": "لا يمكن تحديده"
  },
  "datePicker": {
    "placeholder": "يوم/شهر/سنة",
    "openCalendar": "الاختيار من التقويم",
    "previousMonth": "الشهر السابق",
    "nextMonth": "الشهر التالي",
    "today": "اليوم",
    "clear": "مسح"
  },
  "dateRange": {
    "label": "الفترة",
    "preset": "الفترة",
    "all": "كل التواريخ",
    "thisMonth": "هذا الشهر",
    "lastMonth": "الشهر الماضي",
    "thisYear": "هذه السنة",
    "lastYear": "السنة الماضية",
    "custom": "فترة مخصصة",
    "from": "من",
    "to": "إلى",
    "thisQuarter": "هذا الربع",
    "lastQuarter": "الربع الماضي",
    "today": "اليوم",
    "thisWeek": "هذا الأسبوع"
  },
  "timeline": {
    "zoom": "المقياس",
    "month": "بالأشهر",
    "quarter": "بالأرباع",
    "showTable": "جدول",
    "showChart": "مخطط",
    "today": "اليوم",
    "roleDescription": "مخطط زمني",
    "empty": "لا شيء لعرضه في هذه الفترة.",
    "noDate": "بلا تواريخ",
    "bar": "{{name}}، من {{start}} إلى {{end}}",
    "barProgress": "{{name}}، من {{start}} إلى {{end}}، منجز بنسبة {{progress}}٪",
    "milestone": "{{name}}، مستحق في {{date}}",
    "milestoneDone": "{{name}}، مستحق في {{date}}، تحقق",
    "dragDays": "{{days}} يوم",
    "lateUntil": "متأخر حتى {{date}}",
    "achieved": "تحقق",
    "open": "مفتوح",
    "nextMilestone": "التالي: {{name}} · {{date}} (تحقق {{done}} من {{total}})",
    "allAchieved": "تحققت جميعها ({{total}})",
    "withFact": "{{text}}، {{fact}}",
    "pastEnd": "تجاوز نهايته المخططة",
    "legend": {
      "title": "دليل الرموز",
      "progress": "المنجز حتى الآن",
      "late": "بعد النهاية المخططة",
      "milestone": "معلم رئيسي",
      "milestoneDone": "معلم رئيسي متحقق"
    },
    "columns": {
      "name": "الاسم",
      "start": "البداية",
      "end": "النهاية",
      "progress": "الإنجاز",
      "milestones": "المعالم الرئيسية"
    }
  },
  "sCurve": {
    "planned": "المخطط",
    "earned": "المكتسب",
    "spent": "المصروف",
    "forecast": "المتوقع",
    "budget": "الموازنة",
    "today": "اليوم",
    "showTable": "عرض كجدول",
    "recorded": "مُسجَّل",
    "live": "اليوم، لم يُسجَّل بعد",
    "formula": "تغيّرت طريقة الحساب",
    "endsAt": "← {{amount}} · {{date}}",
    "endsOn": "← {{date}}",
    "finalCost": "التكلفة النهائية المتوقعة، عند الانتهاء في {{date}}",
    "finalCostNoDate": "التكلفة النهائية المتوقعة"
  },
  "treeTable": {
    "expand": "توسيع",
    "collapse": "طي",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل"
  },
  "profileTabs": {
    "goTo": "الانتقال إلى {{tab}}"
  },
  "weekGrid": {
    "total": "الإجمالي",
    "dayTotal": "إجمالي {{day}}",
    "rowTotal": "إجمالي {{row}}",
    "weekTotal": "إجمالي الأسبوع",
    "over24": "أكثر من 24 ساعة",
    "hint": "أدخل الساعات بصيغة 7.5 أو 7:30 أو 7h30.",
    "invalid": "أدخل الساعات بصيغة 7.5 أو 7:30 أو 7h30، بحد أقصى 24 ساعة.",
    "locked": "مقفل",
    "readOnly": "للقراءة فقط",
    "options": "خيارات الصف",
    "today": "اليوم",
    "restDay": "يوم راحة",
    "cell": "{{row}}، {{day}}",
    "keys": "تنقّل بين الأيام والصفوف بمفاتيح الأسهم. اكتب الساعات ثم اضغط Enter لاعتمادها، أو Escape للتراجع، أو Delete للمسح."
  }
}
